module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row font_detail"
  }, [_c('div', {
    staticClass: "col-xs-4 font-bold"
  }, [_c('label', [_vm._v(_vm._s(_vm.description))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  }, [_vm._v(" : ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.descDetail) + "\n\t")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-629fb958!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/calendar_detail.vue
// module id = 3817
// module chunks = 1